import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import interestedIcon from '../../../assets/images/project/icon-interested-purple.svg';
import { GET_CURRENT_USER_me } from '../../../graphql/types/GET_CURRENT_USER';
import { GET_PROJECT_getProject_interested } from '../../../graphql/types/GET_PROJECT';
import { TOGGLE_INTERESTED } from '../../../graphql/types/TOGGLE_INTERESTED';
import { useRedirect } from '../../../hooks/useRedirect';

enum EPageTypes {
  list = 'list',
  project = 'project'
}

const MAX_USERS_TO_DISPLAY = 9;
interface IInterestedProject {
  projectId: string;
  interested: GET_PROJECT_getProject_interested[];
  wasInterestedByUser: boolean;
  pageType?: string;
  projectAuthorId?: string;
  currentUserId?: string;
  user?: GET_CURRENT_USER_me;
}

const InterestedProject: React.FunctionComponent<IInterestedProject> = ({
  projectId,
  interested,
  wasInterestedByUser,
  projectAuthorId,
  currentUserId,
  user
}: IInterestedProject) => {
  const [fakeInterested, setFakeInterested] = useState({
    interestedLength: interested.length,
    wasInterested: wasInterestedByUser
  });

  const [isShowInterestedUsers, setShowInterestedUsers] = useState(false);
  const { redirectToHomePage } = useRedirect();

  // Faking the interested method to improve the UI experience when interested on a project.
  const handlefakeInterested = () => {
    setFakeInterested(prevInterested => {
      const interestedLength = prevInterested.wasInterested
        ? prevInterested.interestedLength - 1
        : prevInterested.interestedLength + 1;

      return {
        ...prevInterested,
        interestedLength,
        wasInterested: !prevInterested.wasInterested
      };
    });
  };

  const [toggleInterested] = useMutation(TOGGLE_INTERESTED, {
    variables: {
      projectId
    }
  });

  return (
    <button
      className={`post-card-interested-button tooltip ${fakeInterested.wasInterested ? 'is-active' : ''}`}
      onClick={async () => {
        if (!user) {
          redirectToHomePage();
          return;
        }
        handlefakeInterested();
        try {
          await toggleInterested();
        } catch (error) {
          handlefakeInterested();
        }
      }}
      onMouseEnter={() => {
          setShowInterestedUsers(true);
      }}
      onMouseLeave={() => {
        setShowInterestedUsers(false);
      }}
    >
      <img src={interestedIcon} alt="interested" className="post-card-interested-icon" />
      <span
        className="post-card-interested-label"
      >
        Interested
      </span>
      {fakeInterested.interestedLength > 0 && (
        <span className="post-card-interested-count">
          {fakeInterested.interestedLength}
        </span>
      )}
      <InterestedUserListTooltip
        isShowInterestedUsers={isShowInterestedUsers}
        interested={interested}
        currentUserId={currentUserId}
        projectAuthorId={projectAuthorId}
      />
    </button>
  );
};

InterestedProject.defaultProps = {
  pageType: EPageTypes.list
};

interface IInteresteredUserListToolTip {
  isShowInterestedUsers: boolean;
  interested: GET_PROJECT_getProject_interested[];
  currentUserId?: string;
  projectAuthorId?: string;
}

const InterestedUserListTooltip = ({
  isShowInterestedUsers,
  interested,
  currentUserId,
  projectAuthorId
}: IInteresteredUserListToolTip) => {
  const isProjectOwner = currentUserId === projectAuthorId;

  if (isShowInterestedUsers && isProjectOwner && interested.length > 0) {
    return (
      <div className="tooltiptext is-size-8">
        {interested.map(
          (interest: GET_PROJECT_getProject_interested, idx: number) => {
            if (idx < MAX_USERS_TO_DISPLAY) {
              return (
                <span className="is-block" key={interest.id}>
                  {interest.author.profile.name}
                </span>
              );
            }
            return undefined;
          }
        )}
      </div>
    );
  }

  if (isShowInterestedUsers) {
    return (
      <div className="tooltiptext is-size-8">
        <span className="is-block">
          Click interested if you want to know more about this project.
        </span>
      </div>
    );
  }

  return null;
};

export default InterestedProject;
